import type { CSSProperties } from 'react';

import { Toaster as Sonner } from 'sonner';
import { Info, Loader2, CircleCheck, OctagonAlert, TriangleAlert } from 'lucide-react';

/** Toasts (sonner) aux couleurs du kit. Les largeurs sont réglées dans `tailwind.css` (`.toaster`). */
export const Toaster = () => (
  <Sonner
    className="toaster"
    closeButton
    expand
    gap={12}
    icons={{
      info: <Info className="size-5 text-cyan-500" />,
      success: <CircleCheck className="size-5 text-green-500" />,
      warning: <TriangleAlert className="size-5 text-amber-500" />,
      error: <OctagonAlert className="size-5 text-destructive" />,
      loading: <Loader2 className="size-5 animate-spin" />,
    }}
    offset={16}
    position="top-right"
    style={
      {
        '--normal-bg': 'var(--popover)',
        '--normal-text': 'var(--popover-foreground)',
        '--normal-border': 'var(--border)',
        '--border-radius': '12px',
        fontFamily: 'var(--font-sans)',
      } as CSSProperties
    }
    toastOptions={{
      classNames: {
        toast: 'shadow-dropdown',
        actionButton: '!bg-primary !text-primary-foreground',
      },
    }}
    visibleToasts={4}
  />
);
